import api from './api.js';

/**
 * Contact service
 */
class Contact {

  /**
     * Constructor
     */
  constructor() {
    // Set URLs
    this.url_contact = '/contact/contact';
    this.url_professional = '/contact/professional';
  }

  /**
     * Create contact message
     * @param {*} data
     * @return {Promise}
     */
  sendContact(data) {
    return api.post(this.url_contact,data);
  }

  /**
     * Send professional contact request
     * @param {*} data 
     */
  sendContactProfessional(data) {
    return api.post(this.url_professional, data);
  }
}

export default new Contact;
